import { render, staticRenderFns } from "./JoinSection.vue?vue&type=template&id=4362430a&"
import script from "./JoinSection.vue?vue&type=script&lang=js&"
export * from "./JoinSection.vue?vue&type=script&lang=js&"
import style0 from "./JoinSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports